import { CommonModule } from '@angular/common';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { IconFonts } from '../../../../Models/IconFonts';
import { IIconFont } from '../../../../Models/Interfaces/IIconFont';
import { IconService } from '../../../Services/IconService';
import { IIconService } from '../../../Services/Interfaces/IIconService';
import { IconComponent } from './Icon';

/**
 * @public
 */
export const ICON_MODULE_CONFIG = new InjectionToken<IIconModuleConfig>('Icon Module Configuration');

/**
 * @internal
 * @factory
 */
export function iconServiceFactory(config: IIconModuleConfig): IIconService {
  const service: IIconService = new IconService()
    .registerIconFonts(config.useDefaults ? IconFonts.forProvider() : [])
    .registerIconFonts(config.iconFonts || []);
  service.defaultIconFont = config.defaultIconFont || service.defaultIconFont;
  (config.svgPathIcons || []).forEach(x => service.addSvgIconFromPath(x.path, x.name, x.fontSet));
  (config.svgUrlIcons || []).forEach(x => service.addSvgIconFromUrl(x.url, x.name, x.fontSet));
  (config.svgXmlIcons || []).forEach(x => service.addSvgIconFromXml(x.xml, x.name, x.fontSet));
  return service;
}

/**
 * @public
 */
@NgModule({
  declarations: [IconComponent],
  exports: [IconComponent],
  imports: [CommonModule],
  providers: [IconService]
})
export class IconModule {
  public static forRoot(config?: Partial<IIconModuleConfig>): ModuleWithProviders<IconModule> {
    return {
      ngModule: IconModule,
      providers: [
        { provide: ICON_MODULE_CONFIG, useValue: config },
        { provide: IconService, useFactory: iconServiceFactory, deps: [ICON_MODULE_CONFIG] }
      ]
    };
  }
}

/**
 * @public
 */
export interface IIconModuleConfig {
  useDefaults: boolean;

  defaultIconFont: IIconFont;

  iconFonts: Array<IIconFont>;

  svgPathIcons: Array<{ path: string; name: string; fontSet?: string }>;

  svgUrlIcons: Array<{ url: string; name: string; fontSet?: string }>;

  svgXmlIcons: Array<{ xml: string; name: string; fontSet?: string }>;
}
